import { partnerScoresApi } from 'legacy/hpscoutso/classes/api/PartnerScoresAPI'
import { partnerScoresItemApi } from 'legacy/hpscoutso/classes/api/PartnerScoresItemAPI'
import { CrudStoreItemHpScout } from 'legacy/hpscoutso/classes/models/CrudStoreItemHpScout'
import { ISustainabilityPlan } from 'legacy/lut/classes/models/ISustainabilityPlan'

import { Crud } from 'core/types/Crud'
import { CrudInnerStorageFetcher } from 'core/types/CrudInnerStorageFetcher'
import { CrudStore } from 'core/types/crudStore'
import { ProcedureInnerStorageFetcher } from 'core/types/ProcedureInnerStorageFetcher'

import { fetchHolidays } from '../../components/widgets/public/activityCalendar/api/fetchHolidays'
import { fetchHolidaysSettings } from '../../components/widgets/public/activityCalendar/api/fetchHolidaysSettings'
import { ICsHubPlanItems } from '../../components/widgets/public/csHubManagement/models'
import { IFormOrderManagement } from '../models/IFormOrderManagement'

import { GetCSHubFormKey } from './GetCsHubFormKey'

class InitializationServiceHpScout {
  public init = () => {
    CrudStore.add(
      new Crud<IFormOrderManagement>({
        fetcher: new CrudInnerStorageFetcher<IFormOrderManagement>('EntryID', {
          formId: 678,
          code: 'WW_REF_ID',
        }),
        keyField: 'EntryID',
      }),
      CrudStoreItemHpScout.WW_REF_ID
    )
    CrudStore.add(
      new Crud<IFormOrderManagement>({
        fetcher: new CrudInnerStorageFetcher<IFormOrderManagement>('EntryId', {
          formId: 678,
          code: 'PartnerRefIDs',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemHpScout.PartnerRefIDs
    )
    CrudStore.add(
      new Crud<IFormOrderManagement>({
        fetcher: new CrudInnerStorageFetcher<IFormOrderManagement>('EntryId', {
          formId: 880,
          code: 'refidext-880',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemHpScout.PartnerRefIDsRequests
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 1573,
          code: 'cs-partner-info-1573',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemHpScout.CSPartnerInfo
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 1574,
          code: 'cs-contacts-info-1574',
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemHpScout.CSContactInfo
    )
    CrudStore.add(
      new Crud<ISustainabilityPlan>({
        fetcher: new CrudInnerStorageFetcher<ISustainabilityPlan>(
          'EntryId',
          GetCSHubFormKey(CrudStoreItemHpScout.CSHubManagement)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItemHpScout.CSHubManagement
    )
    CrudStore.add(
      new Crud<ICsHubPlanItems>({
        fetcher: new CrudInnerStorageFetcher<ICsHubPlanItems>(
          'EntryId',
          GetCSHubFormKey(CrudStoreItemHpScout.CSHubManagementItems)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItemHpScout.CSHubManagementItems
    )
    CrudStore.add(
      new Crud({
        fetcher: new ProcedureInnerStorageFetcher('EntryId', {
          readFromTo: async (filter, sort, paging) => {
            const res = await partnerScoresApi.getPartnerScoresList(filter, paging)
            return res
          },
        }),
        keyField: 'EntryId',
        skipPagingTransform: true,
      }),
      CrudStoreItemHpScout.CSHubPartnerScores
    )
    CrudStore.add(
      new Crud({
        fetcher: new ProcedureInnerStorageFetcher('EntryId', {
          readFromTo: async (filter, sort, paging) => {
            const res = await partnerScoresItemApi.getPartnerScoresList(filter, paging)
            return res
          },
        }),
        keyField: 'EntryId',
        skipPagingTransform: true,
      }),
      CrudStoreItemHpScout.CSHubPartnerScoresItem
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher('EntryId', {
          formId: 1288,
          code: 'recentsearches-1288',
        }),
        keyField: 'EntryId',
        audience: true,
      }),
      CrudStoreItemHpScout.RecentSearches
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher(
          'EntryId',
          GetCSHubFormKey(CrudStoreItemHpScout.CDPReportM01)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItemHpScout.CDPReportM01
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher(
          'EntryId',
          GetCSHubFormKey(CrudStoreItemHpScout.SustainabilityReportM02)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItemHpScout.SustainabilityReportM02
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher(
          'EntryId',
          GetCSHubFormKey(CrudStoreItemHpScout.GHGInventoryM03)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItemHpScout.GHGInventoryM03
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher(
          'EntryId',
          GetCSHubFormKey(CrudStoreItemHpScout.CDPReportDisclosureM04)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItemHpScout.CDPReportDisclosureM04
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher(
          'EntryId',
          GetCSHubFormKey(CrudStoreItemHpScout.CarbonReductionRoadmapM05)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItemHpScout.CarbonReductionRoadmapM05
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher(
          'EntryId',
          GetCSHubFormKey(CrudStoreItemHpScout.ReductionOfCarbonEmissionM06)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItemHpScout.ReductionOfCarbonEmissionM06
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher(
          'EntryId',
          GetCSHubFormKey(CrudStoreItemHpScout.CorporateRoadmapM07)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItemHpScout.CorporateRoadmapM07
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher(
          'EntryId',
          GetCSHubFormKey(CrudStoreItemHpScout.GHGGoalsM08)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItemHpScout.GHGGoalsM08
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher(
          'EntryId',
          GetCSHubFormKey(CrudStoreItemHpScout.CircularEconomyPrinciplesM09)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItemHpScout.CircularEconomyPrinciplesM09
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher(
          'EntryId',
          GetCSHubFormKey(CrudStoreItemHpScout.LanetPartnerM10)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItemHpScout.LanetPartnerM10
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher(
          'EntryId',
          GetCSHubFormKey(CrudStoreItemHpScout.ConductTrainingM11)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItemHpScout.ConductTrainingM11
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher(
          'EntryId',
          GetCSHubFormKey(CrudStoreItemHpScout.HpLifeM12)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItemHpScout.HpLifeM12
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher(
          'EntryId',
          GetCSHubFormKey(CrudStoreItemHpScout.HpLifeCommunityM13)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItemHpScout.HpLifeCommunityM13
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher(
          'EntryId',
          GetCSHubFormKey(CrudStoreItemHpScout.DEIGoalsM14)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItemHpScout.DEIGoalsM14
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher(
          'EntryId',
          GetCSHubFormKey(CrudStoreItemHpScout.SpendAMinimum10PercM15)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItemHpScout.SpendAMinimum10PercM15
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher(
          'EntryId',
          GetCSHubFormKey(CrudStoreItemHpScout.SustainabilityCampaignM16)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItemHpScout.SustainabilityCampaignM16
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher(
          'EntryId',
          GetCSHubFormKey(CrudStoreItemHpScout.SupplierEngageM17)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItemHpScout.SupplierEngageM17
    )
    CrudStore.add(
      new Crud({
        fetcher: new CrudInnerStorageFetcher(
          'EntryId',
          GetCSHubFormKey(CrudStoreItemHpScout.SupplierParticipationIntoResearchM18)
        ),
        keyField: 'EntryId',
      }),
      CrudStoreItemHpScout.SupplierParticipationIntoResearchM18
    )
    CrudStore.add(
      new Crud({
        fetcher: new ProcedureInnerStorageFetcher('EntryId', {
          readFromTo: async () => {
            const res = await fetchHolidays()

            return res
          },
        }),
        keyField: 'EntryId',
        defaultPaging: {
          pageSize: 1000000,
          page: 0,
        },
      }),
      CrudStoreItemHpScout.ACHolidays
    )

    CrudStore.add(
      new Crud({
        fetcher: new ProcedureInnerStorageFetcher('EntryId', {
          readFromTo: async () => {
            const res = await fetchHolidaysSettings()
            return res
          },
        }),
        keyField: 'EntryId',
      }),
      CrudStoreItemHpScout.ACSettings
    )
  }
}

export default new InitializationServiceHpScout()
